<p-card header="Тезисы" *ngIf="data?.length > 0">

  <p-table #dtabs [value]="data" [dataKey]="'id'">
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="title" style="width:50%">
          Тезис <p-sortIcon field="title" />
        </th>
        <th pSortableColumn="lastStatus" style="width:10%">
          Статус <p-sortIcon field="lastStatus" />
        </th>
        <th pSortableColumn="conferenceName" style="width:30%">
          Конференция <p-sortIcon field="conferenceName" />
        </th>
        <th style="width:10%">

        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item>
      <tr>
        <td>
          <div class="mb-1" [innerHTML]="item.title"></div>
        </td>
        <td> <span class="table-badge">{{ item.lastStatus }}</span>
          <span *ngIf="item.isPdf" class="table-badge status-primary pointer" pTooltip="Постер загружен"
            tooltipPosition="left" (click)="onDownloadPoster(item)"><i class="pi pi-file-pdf"></i></span>
          <span *ngIf="item.isVideo" class="table-badge status-closed pointer" pTooltip="Видео добавлено"
            tooltipPosition="left" (click)="onFollowTheLink(item)"><i class="pi pi-video"></i></span>
        </td>
        <td>{{ item.conferenceName }}</td>
        <td> <button *ngIf="item.isPdf" pButton type="button" class="p-button-success mr-1" label="Сертификат"
            icon="pi pi-file-pdf" iconPos="right" (click)="onPrint(item)"></button></td>
      </tr>
    </ng-template>
  </p-table>
  <!-- <div class="list-group">
    <div class="d-flex w-100 justify-content-between list-group-item list-group-item-action" *ngFor="let item of data">
      <a [routerLink]="['/abstract', item.id]" target="_blank">
        <div class="mb-1" [innerHTML]="item.title"></div>
        <small>{{ item.conferenceName }}</small>
      </a>
      <div>
        <span class="table-badge">{{ item.lastStatus }}</span>
        <span *ngIf="item.isPdf" class="table-badge status-primary pointer" pTooltip="Постер загружен"
          tooltipPosition="left" (click)="onDownloadPoster(item)"><i class="pi pi-file-pdf"></i></span>
        <span *ngIf="item.isVideo" class="table-badge status-closed pointer" pTooltip="Видео добавлено"
          tooltipPosition="left" (click)="onFollowTheLink(item)"><i class="pi pi-video"></i></span>
      </div>

      <button *ngIf="item.isPdf" pButton type="button" class="p-button-success mr-1"
      label="Сертификат" icon="pi pi-file-pdf" iconPos="right"
      (click)="onPrint(item)"></button>

    </div> -->


  <!-- </div> -->



</p-card>
